<template>
  <div>
    <v-dialog v-model="dialogVisible" persistent max-width="550">
      <template v-slot:activator="{on, attrs}">
        <v-btn small v-bind="attrs" v-on="on" :disabled="!quoteId">
          <v-icon small left>fas fa-book</v-icon>
          Gerar Apresentação
        </v-btn>
      </template>
      <v-card v-if="state == INTERACTIVE || state == LOADING">
        <v-card-title class="text-h5">
          Selecione o Template da Apresentação
        </v-card-title>
        <v-card-text>
          <v-select
            dense
            :items="templateList"
            item-text="templateName"
            item-value="id"
            v-model="selectedTemplate"
            :loading="state == LOADING"
            :disabled="state == LOADING"
          >
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogVisible = false">
            Cancelar
          </v-btn>
          <v-btn
            text
            :disabled="!selectedTemplate"
            @click="onGeneratePresentation"
          >
            Gerar Apresentação
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="state == PROCESSING">
        <v-card-title class="text-h5">
          Aguarde. Gerando Apresentação ...
        </v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate />
        </v-card-text>
      </v-card>

      <v-card v-if="state == SUCCESS">
        <v-card-title class="text-h5">
          
        </v-card-title>
        <v-card-text>
          <v-alert type="info" dense>
            A apresentação está sendo gerada!<br>
            Em breve estará disponível na aba histórico de apresentações da solicitação de estudo.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogVisible = false"> Fechar </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="state == ERROR">
        <v-card-title class="text-h5"> Erro! </v-card-title>
        <v-card-text>
          <v-alert type="error" dense>
            {{ error }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogVisible = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="state == WARNING">
        <v-card-title class="text-h5"> Aviso </v-card-title>
        <v-card-text>
          <v-alert type="warning" dense>
            {{ error }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogVisible = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StudyService from '@/services/insurancepricing/StudyService';
const LOADING = Symbol();
const SUCCESS = Symbol();
const ERROR = Symbol();
const WARNING = Symbol();
const PROCESSING = Symbol();
const INTERACTIVE = Symbol();

export default {
  data() {
    return {
      dialogVisible: false,
      templateList: [],
      error: null,
      selectedTemplate: null,
      state: LOADING,

      LOADING: LOADING,
      SUCCESS: SUCCESS,
      ERROR: ERROR,
      WARNING: WARNING,
      PROCESSING: PROCESSING,
      INTERACTIVE: INTERACTIVE,
    };
  },
  props: {
    quoteId: [String, Number],
    reportGenerated: null
  },

  watch: {
    dialogVisible(visible) {
      if (visible) {
        this.initDIalog();
      }
    },
  },

  async created() {},

  methods: {
    async initDIalog() {
      console.log('initDIalog');
      this.selectedTemplate = null;
      this.error = null;
      this.state_init();
      try {
        let response = await new StudyService().getTemplates(this.quoteId);
        this.templateList = response.data;
        this.state_next();
      } catch (e) {
        console.log(e);
        this.state_error(e);
      }
    },

    async onGeneratePresentation() {
      this.state_next();
      try{
        new StudyService().generatePresentation(
          this.quoteId,
          this.selectedTemplate
        );
        this.state_next();
        this.isProccessing = false;
      } catch(error){
        this.stateFacade("Não foi possível verificar se a apresentação foi criada. Verifique o histórico de apresentações na solicitação de estudo.", WARNING);
        console.log(error);
        this.isProccessing = false;
      }
    },

    state_init() {
      this.state = LOADING;
    },

    state_error(error) {
      this.stateFacade(error,ERROR)
    },

    stateFacade(msg,type) {
      this.state = type;
      this.error = msg;
    },

    state_next() {
      switch (this.state) {
        case LOADING:
          this.state = INTERACTIVE;
          break;
        case INTERACTIVE:
          this.state = PROCESSING;
          break;
        case PROCESSING:
          this.state = SUCCESS;
          break;
        default:
          this.state = ERROR;
          this.error = `invalid state ${this.state}`;
          break;
      }
    },
  },
};
</script>
